import { createMakeStyles } from "tss-react";

export const Theme = {
    "blue":        '#3AE',
    "darkBlue":    '#29D',
    "brightBlue":  '#4BF',
    "green":       '#3B9',
    "darkGreen":   '#2A8',
    "red":         "#E56",
    "darkRed":     "#D45",
    "normalFont":  22
}

function useTheme() {
    return Theme;
}

export const { makeStyles } = createMakeStyles({ useTheme });
